// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__27zIm","legacyBtn":"MutateMid_legacyBtn__JfAnr"};